import * as React from 'react';

import './icon-styles.css';

export const AlignCenterIcon = () => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
        >
            <rect
                className="icon-align"
                x="7"
                y="7"
                width="18"
                height="2"
            />
            <rect
                className="icon-align"
                x="15"
                y="15"
                width="2"
                height="18"
                transform="translate(-8.17 39.75) rotate(-89.4)"
            />
            <rect
                className="icon-align"
                x="10"
                y="11"
                width="12"
                height="2"
            />
            <rect
                className="icon-align"
                x="7"
                y="15"
                width="18"
                height="2"
            />
            <rect
                className="icon-align"
                x="15"
                y="14"
                width="2"
                height="12"
                transform="translate(-4.17 35.79) rotate(-89.4)"
            />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-align-center.tsx